module.exports = __webpack_public_path__ + "img/05_Module-4@2x.6f90dd3c.jpg";